import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SAVE_GOODS_PURCHASE_SAGA } from "../sagaTypes";
import { loaderAction, storeFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { STORE_FORM_INITIAL } from "../initialStateConstant";
import { getGoodsSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/save_goods_purchase`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerSaveGoodsPurchase(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('user', args.data.user);
        formData.append('goods_id', args.data.goods_id);
        formData.append('establishment', currentEstablishment);
        formData.append('payment', args.data.payment);
        formData.append('discount', args.data.discount);
        formData.append('amount', args.data.amount);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список товаров
            yield put(getGoodsSagaAction());
            // Закрываем форму продажи товара
            yield put(storeFormAction(STORE_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherSaveGoodsPurchase() {
    yield takeLatest(SAVE_GOODS_PURCHASE_SAGA, workerSaveGoodsPurchase);
}